import "../src/global/global-mobile"

import "@modules/vue-modals/ad-free"
import "@modules/solads/solads"
import "@modules/bookmarks/bookmarks-page-mobile"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
